export default __webpack_public_path__ + "static/media/Link.08431a53.svg";